<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12 mt-4">
          <h1>{{ user.username }}</h1>
          <div class="card mb-5">
            <div class="card-body">
              <div class="media">
                <div class="mr-3">
                  <div v-if="!user.logo" class="fa fa-user" style="font-size: 50px; width: 120px; line-height: 120px; text-align: center; background: #333; color: #fafafa; border-radius: 5px"></div>
                  <div v-if="user.logo" style="font-size: 50px; width: 120px; line-height: 120px; text-align: center; border: 1px solid #eee; color: #fafafa; border-radius: 5px; overflow: hidden;">
                    <img :src="user.logo" style="width: 300px;" class="img-fluid">
                  </div>
                </div>
                <div class="media-body">
                  <div v-for="(typez, gamekey) in user.ratings" v-bind:key="gamekey">
                    <h3>{{ gamekey }}</h3>
                    <div class="row">
                      <div class="col" v-for="(type, typekey) in gameTypes" v-bind:key="typekey">
                        <h4><span :class="types[typekey].icon" :style="`--fa-primary-color: ${types[typekey].colorPrimary}; --fa-secondary-color: ${types[typekey].colorSecondary};`"></span>&nbsp;{{ typekey | cap }}</h4>
                        {{ typez[typekey].rating | floor }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import config from '@/config';

export default {
  name: 'Profile',
  computed: {
    gameTypes() {
      return _.omit(this.types, '_');
    },
  },
  created() {
    const db = window.firebase.firestore();
    const docRef = db.collection('users').where('username', '==', this.$route.params.username);

    docRef.get().then((userDocs) => {
      userDocs.forEach((doc) => {
        this.user = doc.data();
      });
    });
  },
  data() {
    return {
      types: config.types,
      user: {},
    };
  },
};
</script>
